var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSignUpRequest = function SvgSignUpRequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 35.9995C72 55.8822 55.8827 71.9995 36 71.9995C16.1173 71.9995 0 55.8822 0 35.9995C0 16.1173 16.1173 0 36 0C55.8827 0 72 16.1173 72 35.9995Z",
    fill: "#50A5ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99023 47.5715H25.8285V31.3979H3.99023V47.5715Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68555 40.0078H22.1315V38.957H7.68555V40.0078Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68555 37.9093H22.1315V36.8613H7.68555V37.9093Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70898 35.8129H22.109V34.7612H7.70898V35.8129Z",
    fill: "#AB5998"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68555 42.106H22.1315V41.0571H7.68555V42.106Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68555 44.2046H14.9083V43.1558H7.68555V44.2046Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0948 8.59326H24.9099C22.8103 8.59326 21.0879 10.3115 21.0879 12.419V59.5846C21.0879 61.6884 22.8103 63.4057 24.9099 63.4057H47.0948C49.1976 63.4057 50.9131 61.6884 50.9131 59.5846V12.419C50.9131 10.3115 49.1976 8.59326 47.0948 8.59326Z",
    fill: "#3776AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.248 55.1217H48.7486V16.8804H23.248V55.1217Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6375 60.4455C33.0732 60.4455 32.6133 59.9857 32.6133 59.4176V59.1101C32.6133 58.541 33.0732 58.083 33.6375 58.083H38.3654C38.9284 58.083 39.3873 58.541 39.3873 59.1101V59.4176C39.3873 59.9857 38.9284 60.4455 38.3654 60.4455H33.6375Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9641 12.7349C36.9641 13.2677 36.5344 13.6946 36.0035 13.6946C35.473 13.6946 35.041 13.2677 35.041 12.7349C35.041 12.2049 35.473 11.7725 36.0035 11.7725C36.5344 11.7725 36.9641 12.2049 36.9641 12.7349Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3875 12.7351C36.3875 12.9465 36.217 13.1165 36.0052 13.1165C35.7924 13.1165 35.6191 12.9465 35.6191 12.7351C35.6191 12.5247 35.7924 12.3491 36.0052 12.3491C36.217 12.3491 36.3875 12.5247 36.3875 12.7351Z",
    fill: "#242D3C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5781 20.1321H63.0878V13.6289H43.5781V20.1321Z",
    fill: "#D16AB9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9062 55.1219H64.5191V50.0122H52.9062V55.1219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2832 24.7042H66.8251V23.6553H54.2832V24.7042Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2832 26.8008H60.5542V25.752H54.2832V26.8008Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0029 27.2217C40.7474 27.2217 44.5936 31.0679 44.5936 35.8124C44.5936 40.557 40.7474 44.4032 36.0029 44.4032C31.2583 44.4032 27.4121 40.557 27.4121 35.8124C27.4121 31.0679 31.2583 27.2217 36.0029 27.2217Z",
    fill: "#FFE9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_10529_11733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.9995H72V0H0V71.9995Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_10529_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2551 40.8362C41.8816 40.5408 41.4259 40.3285 40.9322 40.2254L38.5771 39.7525C38.3304 39.7056 38.152 39.484 38.152 39.2267V38.6864C38.3035 38.4737 38.4461 38.1913 38.5957 37.8958C38.7113 37.6673 38.8864 37.3226 38.9733 37.2334C39.4504 36.7545 39.9107 36.2166 40.0538 35.5226C40.1871 34.8723 40.0561 34.5304 39.9023 34.2559C39.9023 33.5693 39.881 32.7104 39.7188 32.0852C39.6993 31.2393 39.5456 30.7636 39.1591 30.347C38.8864 30.0515 38.4846 29.9828 38.1618 29.928C38.035 29.9066 37.8599 29.8764 37.7953 29.842C37.223 29.5327 36.6572 29.3812 35.9818 29.3696C34.5674 29.4277 32.8287 30.3275 32.2466 31.9319C32.0664 32.4206 32.0845 33.2228 32.0999 33.8671L32.0859 34.2545C31.947 34.5253 31.8109 34.869 31.9452 35.5217C32.0869 36.2166 32.5476 36.7554 33.0331 37.2409C33.1125 37.3226 33.2918 37.6705 33.4098 37.9005C33.5612 38.1945 33.7052 38.476 33.8567 38.6874V39.2276C33.8567 39.4845 33.6774 39.7056 33.4293 39.7539L31.0719 40.2263C30.5814 40.3304 30.1261 40.5408 29.7536 40.8362C29.6375 40.9296 29.5645 41.0661 29.5525 41.2143C29.5408 41.3625 29.5901 41.5074 29.6899 41.618C31.2944 43.3878 33.5956 44.4037 36.0041 44.4037C38.4131 44.4037 40.7152 43.3887 42.3183 41.618C42.4182 41.5074 42.4688 41.3611 42.4558 41.2129C42.4442 41.0648 42.3712 40.9286 42.2551 40.8362Z",
    fill: "#AB5998"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignUpRequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-up-request.2ac50a4d.svg";
export { ForwardRef as ReactComponent };